import React, { useState } from 'react'
import {Link, NavLink} from 'react-router-dom'
import './header.css'

const Header = () => {
 
    const [isMobile, setIsMobile] = useState(false);
  return (
    <nav className='navbar'>
        <h3 className='logo'>Logo</h3>
        <ul className={isMobile ? "nav-links-mobile": "nav-links"}
        onClick={() => setIsMobile(false)}
        >
            <NavLink to='/' className='home'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >
                <li>Home</li>
            </NavLink>
            <NavLink to='/about' className='about-1'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >
                <li>About</li>
            </NavLink>
            <NavLink to='/services' className='services'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >
                <li>Services</li>
            </NavLink>
            <NavLink to='/blog' className='blog'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >
                <li>Blog</li>
            </NavLink>
            <NavLink to='/contact' className='contact'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >
                <li>Contact</li>
            </NavLink>
            <NavLink to='/make-an-appointment' className='appointment'
            style={({isActive})=>{
                return {
                    color: isActive? "#FFDD3C" : "white"
                }
            }}
            >

                <li>Make An Appointment</li>
            </NavLink>
            
        </ul>
        <button className='mobile-menu-icon'
        onClick={() => setIsMobile(!isMobile)}
        >
            {isMobile ? <i className='fas fa-times'></i> : <i className='fas fa-bars'></i>}
        </button>
    </nav>
  )
}

export default Header